import Vue from 'vue'
import Vuex from 'vuex'

import getters from './getters'
import pointto from './modules/covidJump'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    pointto,
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js